export enum SidebarMenuItemType {
    AddEditPlot = 'addeditplot',
    CurrentPlots = 'currentplots',
    AssetLayers = 'assetlayers',
    BackgroundLayers = 'backgroundlayers',
    Debug = 'debug'
}
